import {animate, style, transition, trigger} from '@angular/animations';
import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {OphLoadingModule} from 'src/app/shared/design/oph-loading/oph-loading.module';

const LABEL_ANIMATION_DURATION = '220ms';

@Component({
  selector: 'cs-challenge-day-cycle-selector',
  standalone: true,
  imports: [MatIconModule, OphLoadingModule],
  templateUrl: './cs-challenge-day-cycle-selector.component.html',
  styleUrl: './cs-challenge-day-cycle-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideLabel', [
      transition(':decrement', [
        style({transform: 'translateX(-50px)', opacity: 0}),
        animate(
          `${LABEL_ANIMATION_DURATION} cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
          style({transform: 'translateX(0)', opacity: 1})
        ),
      ]),
      transition(':increment', [
        style({transform: 'translateX(50px)', opacity: 0}),
        animate(
          `${LABEL_ANIMATION_DURATION} cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
          style({transform: 'translateX(0)', opacity: 1})
        ),
      ]),
    ]),
  ],
})
export class CsChallengeDayCycleSelectorComponent {
  readonly displayText = input.required<string>();
  readonly animationKey = input<string | number | null | undefined>();
  readonly prevDisabled = input<boolean>(false);
  readonly nextDisabled = input<boolean>(false);
  readonly loadingDirection = input<'prev' | 'next' | null>(null);

  readonly prev = output<void>();
  readonly next = output<void>();

  onPrevClick(): void {
    this.prev.emit();
  }

  onNextClick(): void {
    this.next.emit();
  }
}
